if (typeof window.WishlistPlusListUIContext === 'undefined') {
  window.WishlistPlusListUIContext = {}
}
if (typeof window.WishlistPlusListUIExtensions === 'undefined') {
  window.WishlistPlusListUIExtensions = {}
}

class SwymWishlistPlusUILayout extends HTMLElement {
  connectedCallback() {
    this.WishlistPlusListType =
      WishlistPlusListUIContext.WishlistPlusListConfig?.WishlistPlusListType
    this.renderUI()
    WishlistPlusListUIExtensions.SwymWishlistPlusListPageActions =
      document.querySelector(
        'swym-wishlist-plus-list-ui-actions#swym-wishlist-plus-list-ui-actions-target-page',
      )
  }

  renderUI() {
    console.log(
      'wishlist config data ',
      WishlistPlusListUIContext.WishlistPlusListConfig,
    )
    let elementTag
    switch (this.WishlistPlusListType) {
      case 'as-drawer':
        elementTag = 'swym-wishlist-plus-list-ui-as-drawer'
        break
      case 'as-section':
        elementTag = 'swym-wishlist-plus-list-ui-as-section'
        break
      case 'as-modal':
        elementTag = 'swym-wishlist-plus-list-ui-as-modal'
        break
      default:
        console.error(
          `Unknown WishlistPlusListType: ${this.WishlistPlusListType}`,
        )
        return
    }

    this.innerHTML = `
        <${elementTag}></${elementTag}>
        <swym-wishlist-plus-list-ui-notification id="swym-wishlist-plus-list-ui-notification"></swym-wishlist-plus-list-ui-notification>
        <swym-wishlist-plus-list-ui-actions id="swym-wishlist-plus-list-ui-actions-target-page" class="swym-wishlist-plus-list-ui-action-for-wishlist-${this.WishlistPlusListType}"></swym-wishlist-plus-list-ui-actions>
      `
  }
}

customElements.define('swym-wishlist-plus-ui-layout', SwymWishlistPlusUILayout)
